import { memo, useEffect } from 'react';
import { Screen, useNavigation } from '@bonanza-social/navigation';
import { useTranslation } from '@bonanza-social/i18n';
import { HistoryType } from '../state/shared/history.types';
import History from '../components/History/History';

function CoinsGamingTransactionsScreen() {
  const navigation = useNavigation();
  const { t } = useTranslation('account');

  useEffect(() => {
    navigation.setOptions({ title: t('coinsGamingHistoryTitle') });
  }, [navigation, t]);

  return (
    <Screen paddingHorizontal="space-0">
      <History type={HistoryType.CoinGaming} />
    </Screen>
  );
}

export default memo(CoinsGamingTransactionsScreen);
